import { useEffect, useRef, useState } from "react";
import backIcon from "../../assets/Back.svg";
import ninto_doctor_logo from "../../assets/ninto-doctor-logo.png";
import ninto_logo from "../../assets/ninto_logo_with_name.svg";
// import QrIcon from "../../assets/Qr_scan_icon.svg";
import PropTypes from "prop-types";
import {
  CloseIcon,
  DoubleTickIcon,
  ExclamatoryIcon,
  LogoutIcon,
  NotificationsIcon,
  ScanIcon,
  SearchIcon,
  SupportIcon
} from "../../assets/assets";
import ninto_corporate_logo from "../../assets/ninto_corporate_logo.svg";
import shareIcon from "../../assets/shareIcon.svg";
import "../../design-system.css";
import { isValidObject } from "../../services/validators";
import RoundedProfilePicture from "../RoundedProfilePicture/RoundedProfilePicture";
import "./Header.css";

function Header(props) {
  const stepperHeaderRef = useRef(null);

  const stepperWidth = () => {
    const singleStepperValue = stepperHeaderRef.current
      ? stepperHeaderRef.current.offsetWidth / props.maxStepperCount
      : 0;
    return singleStepperValue * props.currentStepperValue;
  };

  const clickCountRef = useRef(0);

  const [toast, setToast] = useState("");

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 2000);
  };

  const handleLogoClick = async () => {
    clickCountRef.current += 1;

    const count = clickCountRef.current;

    if (count === 3) {
      showToast("Tap 2 more times to reset the cache...");
    }

    if (count === 4) {
      showToast("Tap 1 more times to reset the cache...");
    }

    if (count !== 5) {
      return;
    }

    try {
      showToast("Resetting app data...");

      // Clear Cache Storage
      if ("caches" in window) {
        const cacheNames = await caches.keys();

        await Promise.all(cacheNames.map((name) => caches.delete(name)));
      }

      // Unregister Service Workers
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();

        await Promise.all(registrations.map((reg) => reg.unregister()));
      }

      // Clear Cookies
      document.cookie.split(";").forEach((cookie) => {
        const eqPos = cookie.indexOf("=");

        const name =
          eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      });

      // Clear Local Storage
      localStorage.clear();

      // Clear Session Storage
      sessionStorage.clear();

      // Clear IndexedDB
      if ("indexedDB" in window && indexedDB.databases) {
        const databases = await indexedDB.databases();

        await Promise.all(
          databases.map((db) => {
            if (db.name) {
              return new Promise((resolve, reject) => {
                const request = indexedDB.deleteDatabase(db.name);

                request.onsuccess = () => resolve();

                request.onerror = () => reject(request.error);

                request.onblocked = () => resolve();
              });
            }

            return Promise.resolve();
          })
        );
      }

      clickCountRef.current = 0;

      showToast("Reset completed");

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error(error);

      showToast("Failed to reset app data");

      clickCountRef.current = 0;
    }
  };

  return (
    <>
      {props.primary === true ? (
        <header
          id="primary-header"
          className={`${
            props.backGroundColor || "background-color-secondary"
          } ${
            props.removeResponsive ? "" : "adaptive-header-height"
          } header-height margin-vertical-auto flex-align-items-center padding-horizontal-large flex-justify-content-space-between right-0 left-0 z-index-1`}
        >
          <HeaderPrefixSection
            handleLogoClick={handleLogoClick}
            inputType={props.inputType}
            searchType={props.searchType}
            searchPlaceHolder={props.searchPlaceHolder}
            searchPrefix={props.searchPrefix}
            userType={props.userType}
            isSearchOn={props.isSearchOn}
            setIsSearchOn={props.setIsSearchOn}
            onSearchUser={props.onSearchUser}
            searchResultElementRef={props.searchResultElementRef}
            searchResults={props.searchResults}
            removeSearchResults={props.removeSearchResults}
            searchKeyword={props.searchKeyword}
            clinicNameAndLocality={props.clinicNameAndLocality}
          />

          <HeaderSuffixSection
            displayName={props.displayName}
            isSearchOn={props.isSearchOn}
            setIsSearchOn={props.setIsSearchOn}
            showSearch={props.showSearch}
            loading={props.loading}
            hideSupport={props.hideSupport}
            showQr={props.showQr}
            supportIconOnClick={props.supportIconOnClick}
            onQrClick={props.onQrClick}
            notificationsCount={props.notificationsCount}
            onProfilePictureClick={props.onProfilePictureClick}
            userProfilePictureSrc={props.userProfilePictureSrc}
            profile-picture-data-cy={props["profile-picture-data-cy"]}
            background={props.background}
            onSearchIconClick={props.onSearchIconClick}
            incident={props.incident}
            incidentOnClick={props.incidentOnClick}
            onTryNintoClick={props.onTryNintoClick}
          />
        </header>
      ) : typeof props.maxStepperCount === "number" ? (
        <header
          ref={stepperHeaderRef}
          className={` ${
            props.backGroundColor
              ? props.backGroundColor
              : "background-color-secondary"
          } ${
            props.removeResponsive ? "" : "adaptive-header-height"
          } header-height right-0 left-0  z-index-1`}
        >
          <div
            className={`${
              props.backGroundColor
                ? props.backGroundColor
                : "background-color-secondary"
            } display-flex flex-align-items-center flex-justify-content-space-between inherit-parent-height`}
          >
            {props.hideBackButton === true ? (
              <div
                className={`${
                  props.removeResponsive ? "" : "adaptive-header-logo-height"
                } header-logo-height`}
              />
            ) : (
              <img
                src={backIcon}
                alt="back-arrow"
                width="auto"
                onClick={props.backButtonOnClick}
                className={`cursor-pointer margin-horizontal-medium ${
                  props.removeResponsive
                    ? ""
                    : "adaptive-back-arrow-row-icon-size"
                }  back-arrow-row-icon-size`}
                data-cy="SECONDARY-HEADER-BACK-ARROW"
              />
            )}
            <div
              className={`${
                props.removeResponsive ? "" : "adaptive-header-logo-height"
              } ${
                props.headerPositionLeft ? "position-absolute" : ""
              } header-logo-height padding-left-larger`}
            >
              <img
                onClick={handleLogoClick}
                data-cy="header-logo"
                src={
                  props.userType === "doctor"
                    ? ninto_doctor_logo
                    : props.userType === "corporate"
                    ? ninto_corporate_logo
                    : ninto_logo
                }
                alt="header-logo"
                width="auto"
                className={`${
                  props.removeResponsive ? "" : "adaptive-header-logo-height"
                } header-logo-height`}
              />
            </div>

            {!props.hideSupport ||
            props.headerSuffixElement ||
            props.showLogoutIcon ? (
              <div className="display-flex flex-align-items-center margin-default">
                {props.showLogoutIcon === true && (
                  <div
                    data-cy="logout-icon"
                    className={`cursor-pointer margin-right-larger ${
                      props.removeResponsive
                        ? ""
                        : "adaptive-support-icon-height"
                    } support-icon-height `}
                    onClick={props.logoutIconOnClick}
                  >
                    <LogoutIcon height="100%" width="100%" color="#4E4E4E" />
                  </div>
                )}
                {props.supportIconOnClick &&
                props.hideSupport === true ? null : (
                  <div
                    data-cy="SUPPORT-ICON"
                    className="margin-right-large flex-place-children-page-center"
                    onClick={props.supportIconOnClick}
                  >
                    <SupportIcon />
                  </div>
                )}
                {props.headerSuffixElement}
              </div>
            ) : (
              <div
                className={`cursor-pointer margin-horizontal-medium padding-top-small ${
                  props.removeResponsive
                    ? ""
                    : "adaptive-back-arrow-row-icon-size"
                }  back-arrow-row-icon-size`}
                data-cy="place-holder-for-centering-img"
              >
                {props.incident === true && (
                  <div
                    className=" flex-justify-content-center"
                    onClick={props.incidentOnClick}
                  >
                    <ExclamatoryIcon color="#E64539" />
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className="stepper-progress-anime"
            style={{
              width: `${stepperWidth()}px`
            }}
          />
        </header>
      ) : (
        <header
          className={`${
            props.backGroundColor
              ? props.backGroundColor
              : "background-color-secondary"
          } ${
            props.removeResponsive ? "" : "adaptive-header-height"
          } header-height display-flex flex-align-items-center flex-justify-content-space-between right-0 left-0 z-index-1`}
        >
          <div className="display-flex flex-align-items-center">
            <img
              src={backIcon}
              alt="back-arrow"
              width="auto"
              onClick={props.backButtonOnClick}
              className={`padding-bottom-smaller cursor-pointer margin-horizontal-large ${
                props.removeResponsive
                  ? ""
                  : "adaptive-back-arrow-row-icon-size"
              } back-arrow-row-icon-size`}
              data-cy="SECONDARY-HEADER-BACK-ARROW"
            />
            <span className="font-size-medium font-family-gilroy-regular font-color-secondary text-transform-capitalize ">
              {props.title}
            </span>
          </div>

          <div className="display-flex flex-align-items-center margin-default">
            {props.incident === true && (
              <div
                className=" margin-right-large flex-justify-content-center"
                onClick={() => {
                  props.incidentOnClick();
                }}
              >
                <ExclamatoryIcon color="#E64539" />
              </div>
            )}

            {props.showShare === true && (
              <img
                data-cy="share-icon"
                className={`cursor-pointer margin-right-medium ${
                  props.removeResponsive ? "" : "adaptive-support-icon-height"
                } support-icon-height `}
                src={shareIcon}
                alt="share-icon"
                width="auto"
                onClick={() => {
                  if (typeof props.shareIconOnClick === "function") {
                    props.shareIconOnClick();
                  }
                }}
              />
            )}

            {props.notification && (
              <div
                className="flex-justify-content-center flex-align-items-center background-white border-radius-default cursor-pointer margin-right-default"
                style={{ padding: "4px 8px" }}
                onClick={() => props.notification.onClick()}
                data-cy="NOTIFICATIONS-ICON"
              >
                <NotificationsIcon />
                {props.notification.count > 0 ? (
                  <span className="font-family-gilroy-regular font-size-small margin-left-small font-color-secondary">
                    {props.notification.count}
                  </span>
                ) : (
                  <></>
                )}
              </div>
            )}

            {typeof props.onMarkAllAsRead === "function" && (
              <div
                className="flex-justify-content-center flex-align-items-center background-white border-radius-default cursor-pointer margin-right-default"
                style={{ padding: "4px 8px" }}
                onClick={props.onMarkAllAsRead}
                data-cy="MARK-ALL-AS-READ"
              >
                <DoubleTickIcon />
                <span className="margin-left-default font-family-gilroy-regular font-color-secondary font-size-small">
                  Mark all as read
                </span>
              </div>
            )}

            {props.showLogoutIcon === true && (
              <div
                data-cy="logout-icon"
                className={`cursor-pointer margin-right-medium ${
                  props.removeResponsive ? "" : "adaptive-support-icon-height"
                } support-icon-height `}
                onClick={props.logoutIconOnClick}
              >
                <LogoutIcon eight="100%" width="100%" color="#4E4E4E" />
              </div>
            )}
            {props.hideSupport === true ? null : (
              <div
                data-cy="SUPPORT-ICON"
                className="margin-right-medium flex-place-children-page-center"
                onClick={props.supportIconOnClick}
              >
                <SupportIcon />
              </div>
            )}
            {typeof props.onTryNintoClick === "function" && (
              <div
                className="font-color-secondary font-family-gilroy-regular font-size-small flex-justify-content-center flex-align-items-center background-white border-radius-default cursor-pointer margin-right-default"
                style={{ padding: "4px 8px" }}
                onClick={props.onTryNintoClick}
                data-cy="TRY-NINTO-BUTTON"
              >
                Try Ninto
              </div>
            )}
            {props.headerSuffixElement}
          </div>
        </header>
      )}
      {/* Toast */}
      {toast && (
        <div
          style={{
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            background: " #e5e5e5",
            color: "black",
            padding: "8px 16px",
            borderRadius: "6px",
            fontSize: "10px",
            opacity: "0.6",
            zIndex: 9999
          }}
          className="position-fixed white-space-no-wrap"
        >
          {toast}
        </div>
      )}
    </>
  );
}

function SearchElement(props) {
  const [searchValue, setSearchValue] = useState("");
  const searchElementRef = useRef(null);
  const inputRef = useRef(null);

  //to set search value
  useEffect(() => {
    if (props.searchPrefix) {
      setSearchValue(props.searchPrefix);
    }
  }, [props.searchPrefix]);
  //set current key values
  useEffect(() => {
    if (
      typeof props.searchKeyword === "string" &&
      searchElementRef.current &&
      document.activeElement !== searchElementRef.current
    ) {
      setSearchValue(props.searchKeyword);
    }
  }, [props.searchKeyword]);
  // set search status
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !(
          searchElementRef.current?.contains(event.target) ||
          props.searchResultElementRef?.current?.contains(event.target) ||
          typeof props.searchKeyword === "string"
        )
      ) {
        props.setIsSearchOn(false);
        // props.removeSearchResults();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      if (isValidObject(props.searchResults)) {
        return;
      }
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [searchElementRef]);

  // set search focus
  useEffect(() => {
    searchElementRef.current?.children[0]?.focus();
  }, []);

  const showSearchIcon = () => {
    return searchValue && searchValue !== props.searchKeyword ? true : false;
  };

  const onClickSearchOrClose = () => {
    if (
      typeof props.searchKeyword === "string" &&
      searchValue === props.searchKeyword
    ) {
      if (typeof props.removeSearchResults === "function") {
        props.removeSearchResults(props.searchKeyword);
      }

      props.setIsSearchOn(false);
    } else {
      props.onSearchUser(searchValue);
    }
  };

  return (
    <div
      className="position-relative inherit-parent-width margin-right-large"
      ref={searchElementRef}
    >
      <input
        ref={inputRef}
        className="font-color-secondary font-size-medium padding-medium border-radius-default inherit-parent-width font-family-gilroy-regular background-white border-1px-e5e5e5"
        id="add"
        type={props.inputType ? props.inputType : "text"}
        name="search"
        data-cy={
          props["data-cy"] ? props["data-cy"] : "HEADER-SEARCH-BAR-INPUT"
        }
        value={searchValue}
        onChange={(event) => {
          event.preventDefault();
          setSearchValue(event.target.value);
        }}
        autoComplete="new_data"
        placeholder={
          typeof props.searchPlaceHolder === "string"
            ? props.searchPlaceHolder
            : "Search"
        }
        onKeyUp={(event) => {
          if (event.key === "Enter") {
            onClickSearchOrClose();
            if (inputRef.current) {
              inputRef.current.blur();
            }
          }
        }}
      />
      <div
        className="position-absolute right-1px top-50-percentage transform-translateY-minus-50-percentage margin-right-medium"
        data-cy={showSearchIcon() ? "searchIcon" : "closeIcon"}
        onClick={onClickSearchOrClose}
      >
        {showSearchIcon() ? <SearchIcon /> : <CloseIcon />}
      </div>
    </div>
  );
}

Header.propTypes = {
  /**
   * callback function for header back arrow onClick
   */
  backButtonOnClick: PropTypes.func,
  /**
   * change background color
   */
  backGroundColor: PropTypes.bool,
  /**
   * clinicNameAndLocality
   */
  clinicNameAndLocality: PropTypes.object,
  /**
   * current stepper value
   */
  currentStepperValue: PropTypes.number,
  /**
   * which you want to search
   */
  searchKeyword: PropTypes.string,
  /**
   * which returns the state of search bar
   * return value `true` or `false`
   */
  onSearchOn: PropTypes.func,
  /**
   * remove adaptiveness in large screen
   */
  removeResponsive: PropTypes.bool,

  /**
   * total number of steps
   */
  maxStepperCount: PropTypes.number,

  /**
   * which renders primary header
   */
  primary: PropTypes.bool,
  /**
   * setIsSearchOn
   */
  setIsSearchOn: PropTypes.func,
  /**
   * onSearchUser
   */
  onSearchUser: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.func,
    PropTypes.string
  ]),
  /**
   * searchResultElementRef
   */
  searchResultElementRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element
  ]),
  /**
   * searchResults
   */
  searchResults: PropTypes.object,
  /**
   * removeSearchResults
   */
  removeSearchResults: PropTypes.any,

  /**
   * show Search bar, available only for primary header
   */
  showSearch: PropTypes.bool,
  /**
   * loading state of header, available only for primary header
   */
  loading: PropTypes.bool,

  /**
   * number of notifications
   */
  notificationsCount: PropTypes.number,
  /**
   * callback function prop for profile picture onClick
   */
  onProfilePictureClick: PropTypes.func,
  /**
   * selector attribute for profile picture
   */
  "profile-picture-data-cy": PropTypes.string,
  /**
   * which hides the back arrow of header. `hideBackButton=true` will hide the back arrow
   */
  hideBackButton: PropTypes.bool,

  /**
   * hides the support icon header
   */
  hideSupport: PropTypes.bool,
  /**
   * headerSuffixElement
   */
  headerSuffixElement: PropTypes.func,

  /**
   * displayName prop for primary header profile picture to show profile picture fallback
   */
  displayName: PropTypes.string,

  /**
   * shareIconOnClick is callback function for share icon onClick
   */
  shareIconOnClick: PropTypes.func,
  /**
   * searchPlaceHolder props used to insert placeholder for header search box
   */
  searchPlaceHolder: PropTypes.string,
  /**
   * searchPrefix prop used to add prefix for header search box
   * Default empty string
   */
  searchPrefix: PropTypes.string,
  /**
   * showShare prop used to show share icon in secondary header default `false`
   */
  showShare: PropTypes.bool,
  /**
   * callback function prop for support icon onClick.
   */
  supportIconOnClick: PropTypes.func,
  /**
   * title for header , not for primary header
   */
  title: PropTypes.string,
  /**
   * user profile picture source. And if the value is null or undefined it shows default avatar
   */
  userProfilePictureSrc: PropTypes.node,
  /**
   * type of user
   */
  userType: PropTypes.string
};

Header.defaultProps = {
  "profile-picture-data-cy": "user-profile-picture",
  backButtonOnClick: undefined,
  backGroundColor: false,
  clinicNameAndLocality: null,
  currentStepperValue: null,
  displayName: "",
  headerSuffixElement: undefined,
  hideBackButton: false,
  hideSupport: false,
  inputType: "",
  loading: false,
  maxStepperCount: null,
  notificationsCount: null,
  onProfilePictureClick: undefined,
  onQrClick: undefined,
  onSearchIconClick: undefined,
  onSearchOn: undefined,
  onSearchUser: null,
  primary: false,
  removeResponsive: false,
  removeSearchResults: null,
  searchKeyword: null,
  searchPlaceHolder: "Search",
  searchPrefix: "",
  searchResultElementRef: null,
  searchResults: null,
  searchType: "",
  setIsSearchOn: false,
  shareIconOnClick: undefined,
  showQr: false,
  showSearch: false,
  showShare: false,
  supportIconOnClick: undefined,
  title: "",
  userProfilePictureSrc: null,
  userType: ""
};

export default Header;

const HeaderPrefixSection = (props) => {
  if (props.isSearchOn === true) {
    return (
      <SearchElement
        inputType={props.inputType}
        onSearchUser={props.onSearchUser}
        removeSearchResults={props.removeSearchResults}
        searchKeyword={props.searchKeyword}
        searchPlaceHolder={props.searchPlaceHolder}
        searchPrefix={props.searchPrefix}
        searchResultElementRef={props.searchResultElementRef}
        searchResults={props.searchResults}
        searchType={props.searchType}
        setIsSearchOn={props.setIsSearchOn}
        onSearchOn={props.onSearchOn}
      />
    );
  }
  return (
    <img
      onClick={props.handleLogoClick}
      className={`${
        props.removeResponsive ? "" : "adaptive-header-logo-height"
      } header-logo-height`}
      data-cy="header-logo"
      alt="header-logo"
      src={
        props.userType === "doctor"
          ? ninto_doctor_logo
          : props.userType === "corporate"
          ? ninto_corporate_logo
          : ninto_logo
      }
      width="auto"
    />
  );
};

const HeaderSuffixSection = (props) => {
  return (
    <div className="display-flex flex-align-items-center margin-top-small">
      {props.isSearchOn === false && (
        <>
          {props.showSearch === true && (
            <div
              className=" margin-right-large flex-justify-content-center"
              data-cy="SEARCH-ICON"
              onClick={() => {
                if (props.loading === false) {
                  if (typeof props.onSearchIconClick === "function") {
                    props.onSearchIconClick();
                  } else {
                    props.setIsSearchOn(true);
                  }
                }
              }}
            >
              <SearchIcon />
            </div>
          )}

          {props.hideSupport === true ? null : (
            <div
              data-cy="SUPPORT-ICON"
              className="margin-right-large flex-place-children-page-center"
              onClick={() => {
                if (
                  props.loading === false &&
                  typeof props.supportIconOnClick === "function"
                ) {
                  props.supportIconOnClick();
                }
              }}
            >
              <SupportIcon />
            </div>
          )}

          {props.showQr === true ? (
            <div
              data-cy="QR-SCAN-ICON"
              className=" margin-right-large flex-justify-content-center"
              alt="QR-SCAN-ICON"
              onClick={() => {
                if (
                  props.loading === false &&
                  typeof props.onQrClick === "function"
                ) {
                  props.onQrClick();
                }
              }}
            >
              <ScanIcon />
            </div>
          ) : (
            <></>
          )}

          {props.incident === true && (
            <div
              className=" margin-right-large flex-justify-content-center"
              data-cy="INCIDENT-ICON"
              onClick={() => {
                props.incidentOnClick();
              }}
            >
              <ExclamatoryIcon color="#E64539" />
            </div>
          )}
        </>
      )}
      {typeof props.onTryNintoClick === "function" && (
        <div
          className="font-color-secondary font-family-gilroy-regular font-size-small flex-justify-content-center flex-align-items-center background-white border-radius-default cursor-pointer margin-right-default"
          style={{ padding: "4px 8px" }}
          onClick={props.onTryNintoClick}
          data-cy="TRY-NINTO-BUTTON"
        >
          Try Ninto
        </div>
      )}

      {typeof props.onProfilePictureClick === "function" ? (
        <RoundedProfilePicture
          size="small"
          displayName={props.displayName}
          background={props.background}
          data-cy={props["profile-picture-data-cy"]}
          loading={props.loading}
          notificationCount={props.notificationsCount}
          onClick={() => {
            if (props.onProfilePictureClick) {
              props.onProfilePictureClick();
            }
          }}
          src={props.userProfilePictureSrc}
        />
      ) : (
        <> </>
      )}
    </div>
  );
};
